import { useEffect, useRef, useState } from 'react'
import { useMediaQuery } from 'usehooks-ts'

import { useAnalytics } from '@shared/lib/analytics'

import styles from './styles.module.scss'

export interface BannerItemProps {
  id?: string;
  title?: string | null;
  desc?: string | null;
  buttonLink?: string;
  buttonText?: string;
  imageDesktop?: string | null;
  imageMobile?: string | null;
  openInNewTab?: boolean;
  size?: 'small' | 'big' | 'default';
}

export default function BannerItem (props: BannerItemProps) {
  const {
    id,
    title,
    buttonLink,
    imageMobile,
    imageDesktop,
    openInNewTab
  } = props
  const isTablet = useMediaQuery('(max-width: 991px)')
  const [ aspectRatio, setAspectRatio ] = useState<string | undefined>(undefined)
  const cardRef = useRef<HTMLDivElement>(null)
  const { trackEvent } = useAnalytics()

  const handleBannerClick = () => {
    trackEvent('select_promotion', {
      promotion_id: id || buttonLink,
      promotion_name: title || 'Banner',
      creative_slot: 'banner_carousel',
    })
  }

  useEffect(() => {
    const imageUrl = isTablet 
      ? (imageMobile || imageDesktop)
      : imageDesktop

    if (!imageUrl) return

    const img = new Image()
    img.onload = () => {
      const ratio = `${img.width}/${img.height}`
      setAspectRatio(ratio)
    }
    img.src = imageUrl
  }, [ imageDesktop, imageMobile, isTablet ])

  return (
    <div 
      ref={cardRef}
      className={styles.card}
      style={aspectRatio ? { aspectRatio } : undefined}
    >
      <div className={styles.card__imageWrapper}>
        {!isTablet && (
          <img
            className={styles.card__bg}
            src={imageDesktop as string}
            alt={title || ''}
            loading="lazy"
            fetchPriority="low"
          />
        )}
        {isTablet && (
          <img
            className={styles.card__bg}
            src={imageMobile ? (imageMobile as string) : (imageDesktop as string)}
            alt={title || ''}
            loading="lazy"
            fetchPriority="low"
          />
        )}
        {buttonLink && (
          <a 
            href={buttonLink} 
            target={openInNewTab ? '_blank' : '_self'}
            className={styles.card__imageLink}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 1
            }}
            aria-label={title ? `Перейти - ${title}` : 'Перейти по ссылке баннера'}
            onClick={handleBannerClick}
          />
        )}
      </div>
    </div>
  )
}
